// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1zXw0","buttons":"SendReceipts_buttons__aPmQt","email":"SendReceipts_email__1_VV3","bookApptTitle":"SendReceipts_bookApptTitle__1lCWQ"};